/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type {
  InternalServerErrorResponse,
  ResolveShareToken200,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Public endpoint that resolves a short share token to the case details needed for login
 * @summary Resolve a share token to case details
 */
export const resolveShareToken = (
  token: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResolveShareToken200>(
    {
      url: `https://api.app.usesky.ai/organizations/share/${token}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getResolveShareTokenQueryKey = (token: string) => {
  return [`https://api.app.usesky.ai/organizations/share/${token}`] as const;
};

export const getResolveShareTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof resolveShareToken>>,
  TError = void | InternalServerErrorResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveShareToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getResolveShareTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof resolveShareToken>>
  > = ({ signal }) => resolveShareToken(token, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof resolveShareToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ResolveShareTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof resolveShareToken>>
>;
export type ResolveShareTokenQueryError = void | InternalServerErrorResponse;

export function useResolveShareToken<
  TData = Awaited<ReturnType<typeof resolveShareToken>>,
  TError = void | InternalServerErrorResponse,
>(
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveShareToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveShareToken>>,
          TError,
          Awaited<ReturnType<typeof resolveShareToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveShareToken<
  TData = Awaited<ReturnType<typeof resolveShareToken>>,
  TError = void | InternalServerErrorResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveShareToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveShareToken>>,
          TError,
          Awaited<ReturnType<typeof resolveShareToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useResolveShareToken<
  TData = Awaited<ReturnType<typeof resolveShareToken>>,
  TError = void | InternalServerErrorResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveShareToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Resolve a share token to case details
 */

export function useResolveShareToken<
  TData = Awaited<ReturnType<typeof resolveShareToken>>,
  TError = void | InternalServerErrorResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof resolveShareToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getResolveShareTokenQueryOptions(token, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
